module.exports = __webpack_public_path__ + "static/icon_opaque-3dde4f7585b5c993782cf6ac281627fb.png";